import { conciergeApiURL } from 'Constants/Constants';
import axios from 'axios';

const conciergeApiClient = axios.create({
    baseURL: conciergeApiURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default conciergeApiClient;
